import { useQuery } from "./useApi";
import { commentaries, type CommentariesFilters } from "../api/commentaries.service.js";

export function useCommentaries(filters?: CommentariesFilters) {
  const statusDep = Array.isArray(filters?.status) ? filters.status.join(",") : filters?.status;

  return useQuery(
    () => commentaries.getAll(filters),
    [
      filters?.limit,
      filters?.offset,
      statusDep,
      filters?.assignee,
      filters?.locationId,
      filters?.bpaId,
      filters?.publicationId,
      filters?.firmId,
    ],
  );
}
